// extracted by mini-css-extract-plugin
export default {"card":"qmhjXnT","wrapper":"cuxzgFS","image":"s1_Sfa_","title":"hv18ll7","description":"ydA3VQZ","dark":"S3J0ESF","light":"XAurJqL","noTitle":"n1gJQss AQi6YMD"};